import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import TreatmentOptions from './TreatmentOptions';
import Faq from './Faq';
import Activities from './Activities';

import reportWebVitals from './reportWebVitals';

import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const router = createHashRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/treatment-options",
    element: <TreatmentOptions />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/activities",
    element: <Activities />,
  },
], {
  basename: "/"
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
